import React from 'react';

const VerifiedBadge = ({ size = 'medium' }) => {
  const sizes = {
    small: { width: '16px', height: '16px', fontSize: '10px' },
    medium: { width: '20px', height: '20px', fontSize: '12px' },
    large: { width: '24px', height: '24px', fontSize: '14px' }
  };

  const style = sizes[size] || sizes.medium;

  return (
    <svg
      width={style.width}
      height={style.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: 'inline-block',
        marginLeft: '6px',
        verticalAlign: 'middle',
        flexShrink: 0
      }}
      title="Verified User"
    >
      {/* Blue circle background */}
      <circle cx="12" cy="12" r="11" fill="#1DA1F2" />
      {/* White checkmark */}
      <path
        d="M9.5 16.5L5.5 12.5L6.91 11.09L9.5 13.67L17.09 6.09L18.5 7.5L9.5 16.5Z"
        fill="white"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default VerifiedBadge;
